<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
        <div slot="modal-title">
            Aporte de Parceiro -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <b-row>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label class="required">Convenente</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="cnpj"
                            placeholder="CNPJ"
                            v-mask="['##.###.###/####-##']"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button
                                variant="primary"
                                @click="pesquisarConvenente()"
                                title="Clique para pesquisar o Convenente">
                                <i class="fa fa-search"></i>
                            </b-button>
                        </b-input-group-append>
                        <b-form-invalid-feedback>O CNPJ é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="9">
                <b-form-group>
                    <label>Razão Social</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            placeholder="Razão Social"
                            v-model="razaoSocial"
                            :disabled="true"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group>
                    <label class="required">Natureza da Despesa</label>
                    <b-input-group>
                        <b-form-select
                            type="text"
                            :options="naturezas"
                            text-field="descricaoCompleta"
                            value-field="idNaturezaDespesa"
                            v-model="idNaturezaDespesa">
                        </b-form-select>
                        <b-form-invalid-feedback>A Natureza é obrigatória</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group>
                    <label class="required">Nome do Evento</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="nomeEvento"
                            placeholder="Nome do Evento"
                        ></b-form-input>
                        <b-form-invalid-feedback>O Nome do Evento é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group>
                    <label class="required">Valor</label>
                    <b-input-group>
                        <money
                        v-model="valor"
                        v-bind="money"
                        class="form-control text-right"
                        ></money>
                        <b-form-invalid-feedback>O Valor é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group>
                    <label class="required">Forma de Aporte</label>
                    <b-input-group>
                        <b-form-select
                            type="text"
                            :options="formasDeAporte"
                            text-field="text"
                            value-field="value"
                            v-model="formaAporte">
                        </b-form-select>
                        <b-form-invalid-feedback>A Forma de Aporte é obrigatória</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import ConveniosServicos from '../../ConveniosServicos';

export default {
    props: {
        convenio: Object,
        aporteParceiro: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        }
    },

    validations: {
        cnpj: { required },
        razaoSocial: { required },
        idNaturezaDespesa: { required },
        nomeEvento: { required },
        valor: { required },
        formaAporte: { required }
    },

    data() {
        return {
            cnpj: null,
            razaoSocial: null,
            idNaturezaDespesa: null,
            naturezas: [],
            nomeEvento: null,
            valor: 0,
            formaAporte: null,
            formasDeAporte:
            [
                { value: 1, text: 'Econômico' },
                { value: 2, text: 'Financeiro' }
            ],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    methods: {
        preencher() {
            if (this.operacaoProp == 'A') {
                this.cnpj = this.aporteParceiro.cnpj
                this.razaoSocial = this.aporteParceiro.razaoSocial
                this.idNaturezaDespesa = this.aporteParceiro.idNaturezaDespesa
                this.nomeEvento = this.aporteParceiro.nomeEvento
                this.valor = this.aporteParceiro.valor
                this.formaAporte = this.aporteParceiro.formaAporte
            } 
        },

        obterNaturezas() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterNaturezas().then((response) => {
                if (response) {
                    if (response.success) {
                        this.naturezas = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        pesquisarConvenente() {
            if (this.cnpj.length == 14 || this.cnpj.length == 18) 
            {
                let cpfcnpjSemCaracteresEspeciais = this.cnpj.replace(/\D+/g, '')
                this.$store.dispatch('addRequest')
                ConveniosServicos.obterFornecedor(cpfcnpjSemCaracteresEspeciais).then((response) => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.erros = []
                            this.razaoSocial = response.data.nome
                        } else {
                            this.erros.push('Convenente não encontrado')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar(){
            this.cnpj = null
            this.razaoSocial = null
            this.naturezaDespesa = null
            this.nomeEvento = null
            this.valor = 0
            this.formaAporte = null
            this.erros = []
        },

        confirmarSalvar(){
            this.$swal({
                title: 'Aporte de Parceiros',
                html: `Confirma a inserção do aporte?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            let aporteDto = {
                cnpj: this.cnpj.replace(/\D+/g, ''),
                razaoSocial: this.razaoSocial,
                idNaturezaDespesa: this.idNaturezaDespesa,
                nomeEvento: this.nomeEvento,
                valor: this.valor,
                formaAporte: this.formaAporte,
                idConvenio: this.$route.params.convenioId
            }
            if (this.operacaoProp == 'A') {
                aporteDto.idAporteParceiro = this.aporteParceiro.idAporteParceiro
            }
            this.$emit('salvar', aporteDto)
            this.resetar()
        },
    },

    mounted() {
        this.obterNaturezas()
    }
}
</script>
